// Если находимся в личном кабинете показывать кнопку Выход
if (App.cookie.get('SID') && document.location.pathname === '/for-students') {
    document.querySelector('#personal-area-btn').style.display = 'none';
    document.querySelector('#personal-area-form-exit').style = 'block';
}

/*
 * Авторизация
*/
function loginInSite() {
    event.preventDefault();
    var form = event.target;
    $.ajax({
        url: '/login',
        type: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        data: new FormData(form),
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            var blockError = document.getElementById('messageOfErrors');
            if (data.result === true) {
                blockError.style.display = 'none';
                location.href = '/for-students';
            } else {
                var message = '';
                for (var prop in data.result) {
                    message = data.result[prop];
                    break;
                }
                blockError.textContent = message;
                blockError.style.display = 'block';
            }
        },
        error: function (error) {
            console.log('Request failed', error);
        }
    });
}

/*
 * Выход
*/
function logout() {
    event.preventDefault();
    var form = event.target;

    $.ajax({
        url: '/login/logout-form',
        type: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        data: form,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            if (data.result) {
                var logoutHomework = document.createElement('img');
                logoutHomework.src = 'https://homework.escc.ru/logout.php';
                logoutHomework.style.display = 'none';

                var logoutCampus = document.createElement('img');
                logoutCampus.src = 'http://campus.escc.ru/index.php?option=com_community&view=profile&task=logout';
                logoutCampus.style.display = 'none';

                document.body.appendChild(logoutHomework);
                document.body.appendChild(logoutCampus);

                if (location.pathname === "/for-students") {
                    location.href = '/login';
                }
            }
        },
        error: function (error) {
            console.log('Request failed', error);
        }
    });
}

/*
 * Регистрация
*/
function registerStudent() {
    event.preventDefault();
    var form = event.target;
    $(form.querySelector('input[type="submit"]')).popover('hide');

    $.ajax({
        url: '/login/register',
        type: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        data: new FormData(form),
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            removeErrors(form);
            var blockError = document.getElementById('messageOfErrors');
            if (data.result === true) {
                blockError.style.display = 'none';
                $('#modal-answer-reg').modal('show');
            } else {
                for (var key in data.errors) {
                    if (form.elements[key]) {
                        form.elements[key].classList.add('is-invalid');
                        form.elements[key].nextElementSibling.textContent = data.errors[key];
                    } else {
                        blockError.textContent = data.errors[key];
                        blockError.style.display = 'block';
                        break;
                    }
                }
            }
        },
        error: function (error) {
            console.log('Request failed', error);
        }
    });
}

/*
 * Восстановление пароля
*/
function recoveryPassword() {
    event.preventDefault();
    var form = event.target;

    $.ajax({
        url: '/login/recovery',
        type: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        },
        data: new FormData(form),
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            if (data.result === true) {
                $('#modal-answer-pass').modal('show');
                removeErrors(form);
            } else {
                form.elements.clientCode.classList.add('is-invalid');
                form.elements.clientCode.nextElementSibling.textContent = data.errors;
            }
        },
        error: function (error) {
            console.log('Request failed', error);
        }
    });
}

function removeErrors(form) {
    [].forEach.call(form.getElementsByClassName('is-invalid'), function (item) {
        item.classList.remove('is-invalid');
    });
}

/*
 * Preloader
 * с аргументом активирует прелоадер внутри формы, без аргумента скрывает прелоадер
 */
function activatePreloader(form) {
    if (form) {
        activatePreloader.form = form;
        activatePreloader.form.querySelector('.preloader').classList.remove("hide");
    } else if (activatePreloader.form) {
        activatePreloader.form.querySelector('.preloader').classList.add("hide");
    }
}
